(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  function setup() {
    document.querySelectorAll('video[data-sash-exploded]').forEach(video => {
      if (video.dataset.ready) return;
      video.dataset.ready = 'true';
      video.muted = true;
      let attempted = false;
      const observer = new IntersectionObserver(entries => {
        if (!video.isConnected) { observer.disconnect(); return; }
        if (entries[0].isIntersecting && !attempted && !reduced.matches) {
          attempted = true;
          video.play().catch(() => {});
        } else if (!entries[0].isIntersecting) video.pause();
      }, { threshold: 0.3 });
      observer.observe(video);
      document.addEventListener('visibilitychange', () => { if (document.hidden) video.pause(); });
      reduced.addEventListener('change', () => { if (reduced.matches) video.pause(); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup);
  else setup();
  document.addEventListener('shopify:section:load', setup);
})();
